import type {
  ActivityDto,
  ActivityDtoPagedResult,
  BoardActivityParams,
  BoardActivitySummaryDto,
} from '../types';

const MOCK_BOARD_ACTIVITIES: ActivityDto[] = [
  {
    id: 'bact-1',
    taskId: 'task-101',
    taskTitle: 'Diseñar dashboard principal',
    actionType: 'task_moved',
    category: 'status_change',
    actorId: 'user-1',
    actorName: 'Guillermo Sandoval',
    actorAvatarUrl: null,
    actorColor: 'purple-violet',
    targetName: 'Completado',
    oldValue: 'En proceso',
    newValue: 'Completado',
    metadata: null,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'bact-2',
    taskId: 'task-102',
    taskTitle: 'Implementar autenticación OAuth',
    actionType: 'comment_added',
    category: 'comment',
    actorId: 'user-2',
    actorName: 'Sara Alejandra',
    actorAvatarUrl: null,
    actorColor: 'coral-flame',
    targetName: 'Implementar autenticación OAuth',
    oldValue: null,
    newValue: 'Ya subí los mockups del banner, avísenme si necesitan ajustes...',
    metadata: null,
    createdAt: new Date(Date.now() - 90 * 60_000).toISOString(),
  },
  {
    id: 'bact-3',
    taskId: 'task-103',
    taskTitle: 'Documentar API endpoints',
    actionType: 'task_assigned',
    category: 'assignment',
    actorId: 'user-3',
    actorName: 'Mónica Esquivel',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: 'Miguel Alejandro',
    oldValue: null,
    newValue: 'Miguel Alejandro',
    metadata: null,
    createdAt: new Date(Date.now() - 150 * 60_000).toISOString(),
  },
  {
    id: 'bact-4',
    taskId: 'task-104',
    taskTitle: 'Diseñar componentes UI',
    actionType: 'attachment_uploaded',
    category: 'attachment',
    actorId: 'user-2',
    actorName: 'Sara Alejandra',
    actorAvatarUrl: null,
    actorColor: 'coral-flame',
    targetName: 'Banner_Q2_mockup.png',
    oldValue: null,
    newValue: null,
    metadata: '{"fileSize":248320}',
    createdAt: new Date(Date.now() - 24 * 60 * 60_000 + 4 * 60 * 60_000).toISOString(),
  },
  {
    id: 'bact-5',
    taskId: 'task-105',
    taskTitle: 'Testing E2E y regresión',
    actionType: 'task_created',
    category: 'general',
    actorId: 'user-4',
    actorName: 'Miguel Alejandro',
    actorAvatarUrl: null,
    actorColor: null,
    targetName: 'Testing E2E y regresión',
    oldValue: null,
    newValue: null,
    metadata: null,
    createdAt: new Date(Date.now() - 24 * 60 * 60_000 + 11 * 60 * 60_000).toISOString(),
  },
  {
    id: 'bact-6',
    taskId: 'task-106',
    taskTitle: 'Optimizar rendimiento de carga',
    actionType: 'task_moved',
    category: 'status_change',
    actorId: 'user-1',
    actorName: 'Guillermo Sandoval',
    actorAvatarUrl: null,
    actorColor: 'purple-violet',
    targetName: 'En proceso',
    oldValue: 'Pendiente',
    newValue: 'En proceso',
    metadata: null,
    createdAt: new Date(Date.now() - 8 * 24 * 60 * 60_000).toISOString(),
  },
];

/** In-memory mock — mirrors `GetBoardActivity`'s `category` filter and pagination behavior. */
export function getMockBoardActivityResult(
  boardId: string,
  params: BoardActivityParams,
): ActivityDtoPagedResult {
  const filtered = params.category
    ? MOCK_BOARD_ACTIVITIES.filter((a) => a.category === params.category)
    : MOCK_BOARD_ACTIVITIES;
  const items = filtered.map((a) => ({ ...a, id: `${boardId}-${a.id}` }));

  const page = params.Page ?? 1;
  const pageSize = params.PageSize ?? 10;
  const start = (page - 1) * pageSize;
  const pageItems = items.slice(start, start + pageSize);

  return {
    items: pageItems,
    page,
    pageSize,
    totalCount: items.length,
    totalPages: Math.max(1, Math.ceil(items.length / pageSize)),
    hasNextPage: start + pageSize < items.length,
  };
}

/** In-memory mock for `GetBoardActivitySummary` — a fixed "today" snapshot, ignores the `from`/`to` range. */
export function getMockBoardActivitySummary(): BoardActivitySummaryDto {
  return {
    totalChanges: 6,
    completedTasks: 1,
    newComments: 1,
    mostActiveUser: { id: 'user-2', name: 'Sara Alejandra', avatarUrl: null, color: 'coral-flame' },
    perPerson: [
      { userId: 'user-2', name: 'Sara Alejandra', avatarUrl: null, color: 'coral-flame', count: 2 },
      {
        userId: 'user-1',
        name: 'Guillermo Sandoval',
        avatarUrl: null,
        color: 'purple-violet',
        count: 2,
      },
      { userId: 'user-3', name: 'Mónica Esquivel', avatarUrl: null, color: null, count: 1 },
      { userId: 'user-4', name: 'Miguel Alejandro', avatarUrl: null, color: null, count: 1 },
    ],
  };
}
